import '../../../../../../../app/assets/javascripts/pages/projects/show/index.js?vue3';
import initTierBadgeTrigger from '../../../groups/init_tier_badge_trigger.js?vue3';
import initVueAlerts from '../../../../../../../app/assets/javascripts/vue_alerts.js?vue3';
import { initComplianceInfo } from './init_compliance_info.js?vue3';
import { initDuoOtelInfo } from './init_duo_otel_info.js?vue3';

initVueAlerts();
initTierBadgeTrigger();
initComplianceInfo();
initDuoOtelInfo();
